@let obs =
  {
    order: order$ | async,
  };

<!--Это блядство нужно отрефакторить, после того как статусы на бэке будут изменены-->
@if (obs.order) {
  <div class="body-item">
    <p>Заказ №{{ obs.order.code }} оформлен,</p>

    @if (!obs.order.isB2BOrder) {
      @if (obs.order.orderState) {
        @if (obs.order.orderState.dateFormattedValue) {
          <p>можно забрать {{ obs.order.orderState.dateFormattedValue }}</p>
        } @else {
          @if (obs.order.orderState.status === 'Можно забрать через 1 минуту') {
            <p>готовим к выдаче</p>
          } @else {
            <p>{{ obs.order.orderState.status }}</p>
          }
        }
      }
    } @else {
      @if (obs.order.deliveryMode?.code === 'delivery') {
        <p>Заказ будет доставлен после поступления денежных средств.</p>
      } @else if (obs.order.deliveryMode?.code === 'pickup') {
        <p>Заказ можно будет забрать после поступления денежных средств.</p>
      }
    }
  </div>
  <p class="body-item">
    <a sdLink [routerLink]="['/my-account/order/', obs.order.code]">Статус заказа</a>
  </p>
  <p>Не сдавайтесь - стройтесь</p>
}
